import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function YourJourneyStartsHere() {
  return <section data-section-id="224922" id="hero-estratégia-digital-produção-de-conteúdo-e-posicionamento-para-empresas-em-são-paulo" className="bg-background text-foreground relative min-h-[80vh] flex items-center justify-center overflow-hidden py-24 lg:py-32 animate-in fade-in slide-in-from-bottom-5 duration-1000">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/sao_paulo_skyline_minimalist.png')]" />
        {}
        <div className="absolute inset-0 bg-background/95" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 text-center">
        <h1 className="font-default text-5xl md:text-6xl lg:text-[64px] leading-tight font-bold mb-6 text-foreground tracking-tighter">
          Serviços de Produção Audiovisual e Marketing Digital em São Paulo
        </h1>
        
        <p className="font-sans text-xl md:text-2xl mb-12 text-muted-foreground max-w-3xl mx-auto font-normal leading-relaxed">
          Da gravação ao resultado: estúdio de podcast, produção de vídeo e estratégias digitais para empresas que querem crescer com conteúdo.
        </p>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground font-semibold h-14 px-10 text-lg rounded-full shadow-lg shadow-primary/20 transition-all hover:scale-105 hover:bg-primary/90">
            <Link to="https://wa.me/5511969100007">Falar no WhatsApp</Link>
          </Button>
        </div>
      </div>
    </section>;
}